/**
 * Centralized URL patterns configuration for all tracking services
 * All URL patterns use buildUrl placeholders for automatic context detection
 */

export const URL_PATTERNS = {
	// Application-specific API endpoints (relative paths)
	APP_IDENT: {
		ABYLAWEB: '/abylaweb/api/user/me',
		DEFAULT: '/api/svc/service-users/v1/me',
		KEEP: '/api/user/me',
		MODEL: '/abylaweb/api/user/me',
	},

	// Identity API Patterns
	IDENT_API: 'https://api{currentStack}.stonal{currentProviderDomain}{currentEnvironment}.io/users/v1/me',
	// OpenObserve Service Patterns
	OPENOBSERVE_API: 'https://api.stonal{currentProviderDomain}{currentEnvironment}.io',
	RUDDER_CONFIG: 'https://api.rudder.stonal.io',
	// RudderStack Service Patterns
	// Note: RudderStack services may not follow provider domain patterns - keeping original for now
	RUDDER_DATAPLANE: 'https://dataplane.rudder.stonal.io',

	RUDDER_PLUGINS_SDK: 'https://cdn.rudder.stonal.io/v3/modern/plugins',

	RUDDER_SDK_BASE: 'https://cdn.rudder.stonal.io/v3/modern/js-integrations',
} as const;

/**
 * URL pattern types for TypeScript support
 */
type UrlPatternKey = keyof typeof URL_PATTERNS;
type AppIdentPatternKey = keyof typeof URL_PATTERNS.APP_IDENT;

/**
 * Get a URL pattern by key
 * @param patternKey - The pattern key to retrieve
 * @returns The URL pattern string
 */
export function getUrlPattern(patternKey: Exclude<UrlPatternKey, 'APP_IDENT'>): string {
	return URL_PATTERNS[patternKey] as string;
}

/**
 * Get an app-specific identity API pattern
 * @param appKey - The app-specific pattern key
 * @returns The relative path pattern
 */
export function getAppIdentPattern(appKey: AppIdentPatternKey): string {
	return URL_PATTERNS.APP_IDENT[appKey];
}